/**
 * Global callback for token refresh
 * This allows api.ts (non-React code) to trigger token refresh in AuthContext
 */

type RefreshTokenCallback = () => Promise<string | null>;

let refreshTokenCallback: RefreshTokenCallback | null = null;

/**
 * Set the refresh token callback (called by AuthContext)
 */
export const setRefreshTokenCallback = (callback: RefreshTokenCallback) => {
  refreshTokenCallback = callback;
};

/**
 * Clear the refresh token callback
 */
export const clearRefreshTokenCallback = () => {
  refreshTokenCallback = null;
};

/**
 * Call the refresh token callback (called by api.ts)
 */
export const callRefreshToken = async (): Promise<string | null> => {
  if (refreshTokenCallback) {
    return await refreshTokenCallback();
  }
  return null;
};
